var map = {
	"./robuxContainerBaseDirective.js": 39,
	"./robuxContainerCnbDirective.js": 40,
	"./robuxContainerDirective.js": 41,
	"./robuxPackageCnbDirective.js": 42,
	"./robuxPackageDirective.js": 43,
	"./robuxSubscriptionUpsellContainerDirective.js": 44,
	"./robuxSubscriptionUpsellPackageDirective.js": 45
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38;